import { History, IntegrationInstructions } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";
import { ScheduleIntegrator } from "./ScheduleIntegrator";
import { useViewContext } from "@/contexts/ViewContext";

export function useScheduleIntegrator() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();

  const configs: IFeatures = {
    active:
      access?.type === "professional" &&
      (availableRoles?.includes("manager") ||
        availableRoles?.includes("owner")),
    path: "/scheduleintegration",
    icon: IntegrationInstructions,
    text: "Exposição de agendas",

    sideMenu: true,
    sideMenuIndex: 3,

    subitem: true,
    parent: "Configurações",
    avatarIndex: 2,

    component: () => <ScheduleIntegrator />,
  };

  return configs;
}
